
define('text!templates/alert.html',[],function () { return '<div class="{{className}} w-AlertDialog">\n\t<div class="w-body">\n\t\t<div class="icon"><b></b></div>\n\t\t<div class="message">\n\t\t\t<div class="head">{{header}}</div>\n\t\t\t<div class="message-c">{{{message}}}</div>\n\t\t</div>\n\t</div>\n</div>';});

